import React from 'react'
import Current_rank_cards from './current_rank_cards/Current_rank_cards'
import Current_rank_main_card from './current_rank_main_card/Current_rank_main_card'

function Current_rank_cards_section() {
    return (
        <>
            <section className='Current_rank_cards_section'>

                <Current_rank_main_card />

                <Current_rank_cards imgSrc={"/assets/images/profile/current_rank/current_rank_cards/img_1.png"}/>
                <Current_rank_cards imgSrc={"/assets/images/profile/current_rank/current_rank_cards/img_2.png"}/>
                <Current_rank_cards imgSrc={"/assets/images/profile/current_rank/current_rank_cards/img_3.png"}/>
                <Current_rank_cards imgSrc={"/assets/images/profile/current_rank/current_rank_cards/img_4.png"}/>
            </section>
        </>
    )
}

export default Current_rank_cards_section